import React from "react";
import PropTypes from "prop-types";
import "./styles.scss";

import {
  Button,
  ButtonIcon,
  CustomTag,
  GroupHeader,
  Input,
} from "../../../components";

import { RiFileUploadLine } from "react-icons/ri";
import { GetIcon } from "../../../config/icon";
import { Scrollbars } from "react-custom-scrollbars";

const Index = (props) => (
  <>
    <GroupHeader option={"mt-1 mb-2"} title={props.title} />

    {!props.logoURL && (
      <div className={"cco_ad_img-upload-wrapper"}>
        {!props.isImageUploading && (
          <>
            <input
              id="eventImageUpload"
              type="file"
              onChange={props.onSelectFile}
              hidden
            />

            <Button
              rightIconFill={true}
              rightIcon={false}
              iconName={GetIcon("fileUpload")}
              text={"Upload"}
              onClick={() => {
                document.getElementById("eventImageUpload").click();
              }}
              type={"btn-upload"}
            />
            <div className="eiu_title">Choose files to upload </div>
            <div className="eiu_text">
              Only jpg,jpeg,png file with maximum size of 2MB is allowd
            </div>
            {props.fileName && (
              <div className={"file-details-wrp"}>
                <div className={"file-name"}>{props.fileName}</div>
              </div>
            )}
          </>
        )}
        {props.isImageUploading && (
          <>
            <div className={"event-img-upload"}>Uploading...</div>
          </>
        )}
      </div>
    )}
  </>
);

Index.propTypes = {};

Index.defaultProps = {};

export default Index;
